export declare type ErrorInterface = Error;

export declare class Error implements ErrorInterface {
    name: string;
    message: string;
}

export class Exception extends Error {
    prototype: any;
    constructor(message: string, public detalles?: any, public innerException?: any) {
        super()
        this.message = message;       
        this.name = this.constructor.name;
    }
}
